module.exports = __webpack_public_path__ + "static/img/rank_93.8a3df27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_93.png
// module id = saxW
// module chunks = 0